import { TRADE_IN_DEVICE_STORAGE } from '@vfde-fe/sails-constants';
import { getSessionStorage } from '@vfde-fe/sails_core';
import { Device } from '../interface';

/**
 * get device from storage
 */
export const getDeviceFromStorage = (): Device => {
    return getSessionStorage(TRADE_IN_DEVICE_STORAGE);
};
